function initializeAddressAutocomplete(inputId) {
  const autocompleteInput = document.getElementById(inputId);
  if (!autocompleteInput) return;

  const fieldsContainer = findSiblingFieldsContainer(autocompleteInput);
  if (!fieldsContainer) return;

  const options = {
    fields: ["address_components"],
    types: ["address"],
  };

  const autocomplete = new google.maps.places.Autocomplete(autocompleteInput, options);

  google.maps.event.addListener(autocomplete, "place_changed", function() {
    onPlaceChanged(autocomplete, fieldsContainer);
  });
}

function findSiblingFieldsContainer(autocompleteInput) {
  const container = autocompleteInput.closest('[data-address-autocomplete-target="container"]');
  if (!container) return null;

  const parent = container.parentElement;
  if (!parent) return null;

  return parent.parentElement.querySelector('[data-address-autocomplete-target="fields"]');
}

function onPlaceChanged(autocomplete, fieldsContainer) {
  const place = autocomplete.getPlace();
  if (!place.address_components) return;

  let streetNumber = "";
  let route = "";

  for (const component of place.address_components) {
    for (const type of component.types) {
      if (type === "street_number") {
        streetNumber = component.short_name;
      } else if (type === "route") {
        route = component.short_name;
      } else if (type === "locality") {
        setFieldValue(fieldsContainer, "city", component.short_name);
      } else if (type === "postal_code") {
        setFieldValue(fieldsContainer, "postal_code", component.short_name);
      } else if (type === "country") {
        setFieldValue(fieldsContainer, "country", component.short_name, true);
      }
    }
  }

  const fullAddress = [streetNumber, route].filter(Boolean).join(" ");
  setFieldValue(fieldsContainer, "street", fullAddress);
}

function setFieldValue(container, fieldType, value, dispatchChange) {
  const field = container.querySelector(`[data-address-field="${fieldType}"]`);
  if (field) {
    field.value = value;
    if (dispatchChange) {
      field.dispatchEvent(new Event("change"));
    }
  }
}

function initializeAllAddressAutocompletes() {
  initializeAddressAutocomplete("user_autocomplete_address");
  initializeAddressAutocomplete("legal_entity_autocomplete_address");
}

if (typeof google !== "undefined") {
  window.addEventListener("load", initializeAllAddressAutocompletes);
}
